export function miniAppNavigateTo (url) {
  if (window.my) {
    return window.my.navigateTo({ url })
  } else {
    return window.wx.miniProgram.navigateTo({ url })
  }
}

export function miniAppSwitchTab (url) {
  if (window.my) {
    return window.my.switchTab({ url })
  } else {
    return window.wx.miniProgram.switchTab({ url })
  }
}
export function miniAppRedirectTo (url) {
  if (window.my) {
    return window.my.redirectTo({ url })
  } else {
    return window.wx.miniProgram.redirectTo({ url })
  }
}

export function miniAppReLaunch (url) {
  if (window.my) {
    return window.my.reLaunch({ url })
  } else {
    return window.wx.miniProgram.reLaunch({ url })
  }
}

export function miniAppPostMessage (data) {
  if (window.my) {
    return window.my.postMessage(data)
  } else {
    return window.wx.miniProgram.postMessage(data)
  }
}
